import React from "react";
import { useNavigate } from "react-router-dom";

import { Text } from "@performyard/py-components";

// components
import Button from "../../../../../components/Button";
import BaseModal from "../../../../../components/Modal/BaseModal";
import Spacer from "../../../../../components/Spacer";

// hooks
import { useDeleteCompanyForm } from "../../../../../api/hooks";

type DeleteFormModalProps = {
	deleteFormId: string;
	deleteFormName: string;
	handleClose: () => void;
	rerouteUrl?: string;
};

const DeleteFormModal = ({ deleteFormId, handleClose, rerouteUrl, deleteFormName }: DeleteFormModalProps) => {
	const navigate = useNavigate();

	const { mutate: deleteForm, isPending } = useDeleteCompanyForm({
		onSuccess: () => {
			handleClose();
			if (rerouteUrl) {
				navigate(rerouteUrl);
			}
		},
	});

	return (
		<BaseModal isOpen={!!deleteFormId} handleClose={handleClose}>
			<div className="flex flex-col items-center">
				<Text weight="semi-bold" size="sub-heading">
					Delete form?
				</Text>
				<div className="min-w-0 max-w-[360px] pb-4">
					<div className="line-clamp-1">
						<Text weight="regular" size="paragraph-1">
							{deleteFormName}
						</Text>
					</div>
				</div>
				<Text weight="regular" size="paragraph-1">
					This action cannot be undone.
				</Text>
				<Spacer height={3} />
				<div className="flex justify-center gap-2 pb-4">
					<Button onClick={handleClose} size="large" testid="cancelButton">
						Cancel
					</Button>
					<Button
						isRequesting={isPending}
						color="red"
						onClick={() => deleteForm(deleteFormId)}
						size="large"
						testid="deleteFormButton"
					>
						Yes, Delete Form
					</Button>
				</div>
			</div>
		</BaseModal>
	);
};

export default DeleteFormModal;
